<template>
<!-- 借贷宝订单管理 -->
  <div>
    <el-dialog
      :visible.sync="visible"
      @open="dialogOpen"
      @closed="dialogClosed"
      width="1200px"
      title="账户余额信息"
    >
      <div class="action">
        <el-checkbox v-model="hideZero">隐藏余额为0的币种</el-checkbox>
      </div>
      <el-table :data="userWallet | filterList(hideZero)">
        <el-table-column prop="coinType" label="币种"> </el-table-column>
        <el-table-column prop="currentInterest" label="活期利息">
        </el-table-column>
        <el-table-column label="C2C买入/卖出">
          <template slot-scope="scope"
            >{{ scope.row.c2cBuy }}/{{ scope.row.c2cSell }}</template
          >
        </el-table-column>
        <el-table-column prop="contractRebateTotal" label="合约返佣总额"></el-table-column>
        <el-table-column label="OTC买入/卖出">
          <template slot-scope="scope"
            >{{ scope.row.otcBuy }}/{{ scope.row.otcSell }}</template
          >
        </el-table-column>
        <el-table-column label="充值/提现">
          <template slot-scope="scope"
            >{{ scope.row.deposit }}/{{ scope.row.withdrawal }}</template
          >
        </el-table-column>
        <el-table-column label="(站内)充值/提现">
          <template slot-scope="scope"
            >{{ scope.row.internalDeposit }}/{{
              scope.row.internalWithdrawal
            }}</template
          >
        </el-table-column>
        <el-table-column label="合约买入/卖出">
          <template slot-scope="scope"
            >{{ scope.row.contractBuy }}/{{ scope.row.contractSell }}</template
          >
        </el-table-column>
        <el-table-column label="WALLET可用/冻结">
          <template slot-scope="scope"
            >{{ scope.row.coinAmount }}/{{ scope.row.coinFroze }}</template
          >
        </el-table-column>
        <el-table-column label="OTC可用/冻结">
          <template slot-scope="scope"
            >{{ scope.row.otcCoinAmount }}/{{
              scope.row.otcCoinFroze
            }}</template
          >
        </el-table-column>
        <el-table-column label="超级合约可用/冻结">
          <template slot-scope="scope"
            >{{ scope.row.generalAvailableAmount }}/{{
              scope.row.generalFrozeAmount
            }}</template
          >
        </el-table-column>
        <el-table-column label="超级合约盈亏" prop="generalProfit" />
        <el-table-column label="合约可用/冻结">
          <template slot-scope="scope"
            >{{ scope.row.contractAvailableAmount }}/{{
              scope.row.contractFrozeAmount
            }}</template
          >
        </el-table-column>
        <el-table-column prop="totalAmount" label="总量" /> </el-table
    ></el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      uid: "",
      visible: false,
      hideZero: true,
    };
  },
  computed: {
    ...mapState("FinanceManage", ["userWallet"]),
  },
  methods: {
    ...mapActions("FinanceManage", ["getUserWallet"]),
    setUid(uid) {
      this.uid = uid;
    },
    setVisible(val) {
      this.visible = val;
    },
    dialogOpen() {
      this.getUserWallet({
        userId: this.uid,
      });
    },
    dialogClosed() {},
  },
  filters: {
    filterList: (value, isHide) => {
      return value.filter((item) =>
        isHide
          ? item.currentInterest !== 0 ||
            item.c2cBuy !== 0 ||
            item.c2cSell !== 0 ||
            item.deposit !== 0 ||
            item.withdrawal !== 0 ||
            item.coinAmount !== 0 ||
            item.coinFroze !== 0 ||
            item.totalAmount !== 0 ||
            item.internalDeposit !== 0 ||
            item.internalWithdrawal !== 0 ||
            item.otcCoinAmount !== 0 ||
            item.otcCoinFroze !== 0 ||
            item.generalAvailableAmount !== 0 ||
            item.generalFrozeAmount !== 0 ||
            item.contractAvailableAmount !== 0 ||
            item.contractFrozeAmount !== 0 ||
            item.generalProfit !== 0
          : true
      );
    },
  },
};
</script>

<style scoped lang="less">
.action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 20px;
}
</style>
